import React from 'react';

import { Circle, Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { FooterStyles, RectangleShapeStyles } from './Footer.styles';
import type { InstagramStoryComponentsProps } from './types';

export function Footer(props: InstagramStoryComponentsProps): React.JSX.Element | null {
	const { size, loading } = props;

	if (size === 'xsmall' && loading) {
		return null;
	}

	return (
		<SkeletonContainer
			className={FooterStyles({ size })}
			shapeColorClassName="bg-icon-weak"
			shapeSize={size}
			loading={loading}
		>
			<Rectangle className={RectangleShapeStyles({ size })} rounded />
			<Circle />
			<Circle />
		</SkeletonContainer>
	);
}
